<template>
<section>
    <v-row v-if="items.length === 0">
        <v-col cols="12">
            <h5 class="text-h5">No hay resultados</h5>
        </v-col>
    </v-row>
    <v-row v-else>
        <v-col cols="12" sm="6" md="4" lg="4" xl="3" v-for="(data,i) in items" :key="i">
            <v-card outlined class="bg_none oink">
                <v-card-title class="text-primary text-p font-weight-black">{{data.description}}</v-card-title>
                <v-card-subtitle class="text-primary text-p"><b>Tipo:</b> {{data.type_description}} <br> <b>Ubicación:</b> {{data.location}}</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text class="text-left">
                    <v-list color="transparent" class="pa-0">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-primary text-p font-weight-black">Estado General</v-list-item-title>
                                <v-list-item-subtitle v-if="data.status_date">{{getDate(data.status_date)}}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon color="success" v-if="data.status_code === 200">mdi-circle</v-icon>
                                <v-icon color="warning" v-if="data.status_code === 300">mdi-circle</v-icon>
                                <v-icon color="error" v-if="data.status_code === 500">mdi-circle</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-primary text-p font-weight-black">Estado Bóveda</v-list-item-title>
                                <v-list-item-subtitle v-if="data.vault_status_date">{{getDate(data.vault_status_date)}}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon color="success" v-if="data.vault_status_code === 200">mdi-circle</v-icon>
                                <v-icon color="warning" v-if="data.vault_status_code === 300">mdi-circle</v-icon>
                                <v-icon color="error" v-if="data.vault_status_code === 500">mdi-circle</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-primary text-p font-weight-black">Estado Validador</v-list-item-title>
                                <v-list-item-subtitle v-if="data.coin_validator_status_date">{{getDate(data.coin_validator_status_date)}}</v-list-item-subtitle>
                                <v-list-item-subtitle v-if="data.coin_validator_status_message">{{data.coin_validator_status_message}}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon color="success" v-if="data.coin_validator_status_code === 200">mdi-circle</v-icon>
                                <v-icon color="warning" v-if="data.coin_validator_status_code === 300">mdi-circle</v-icon>
                                <v-icon color="error" v-if="data.coin_validator_status_code === 500">mdi-circle</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-primary text-p font-weight-black">Último Login</v-list-item-title>
                                <v-list-item-subtitle v-if="data.last_login_date">{{getDate(data.last_login_date)}}</v-list-item-subtitle>
                                <v-list-item-subtitle v-if="data.last_login_message">{{data.last_login_message}}</v-list-item-subtitle>

                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon color="success" v-if="data.last_login_code === 200">mdi-circle</v-icon>
                                <v-icon color="warning" v-if="data.last_login_code === 300">mdi-circle</v-icon>
                                <v-icon color="error" v-if="data.last_login_code === 500">mdi-circle</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-primary text-p font-weight-black">Último Depósito</v-list-item-title>
                                <v-list-item-subtitle v-if="data.last_deposit_date">{{getDate(data.last_deposit_date)}}</v-list-item-subtitle>
                                <v-list-item-subtitle v-if="data.last_deposit_message">{{data.last_deposit_message}}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon color="success" v-if="data.last_deposit_code === 200">mdi-circle</v-icon>
                                <v-icon color="warning" v-if="data.last_deposit_code === 300">mdi-circle</v-icon>
                                <v-icon color="error" v-if="data.last_deposit_code === 500">mdi-circle</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-primary text-p font-weight-black">Último Logout</v-list-item-title>
                                <v-list-item-subtitle v-if="data.last_logout_date">{{getDate(data.last_logout_date)}}</v-list-item-subtitle>
                                <v-list-item-subtitle v-if="data.last_logout_message">{{data.last_logout_message}}</v-list-item-subtitle>

                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon color="success" v-if="data.last_logout_code === 200">mdi-circle</v-icon>
                                <v-icon color="warning" v-if="data.last_logout_code === 300">mdi-circle</v-icon>
                                <v-icon color="error" v-if="data.last_logout_code === 500">mdi-circle</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="success" depressed block :to="`/dashboard/detail/${data.id}/${data.description}`">Ver detalle</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</section>
</template>

<script>
export default {
    name: 'OinkItem',
    props: ['items'],
    data() {
        return {}
    },
    methods: {
        getDate(d) {
            const date = d.split('T');
            return `${date[0]}, ${this.getTime(date[1])}`;
        },
        getTime(time) {
            if (time.indexOf('.') !== -1) {
                time = time.split('.')[0];
            }
            time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
            if (time.length > 1) { // If time format correct
                time = time.slice(1); // Remove full string match value
                time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
                time[0] = +time[0] % 12 || 12; // Adjust hours
            }
            return time.join('');
        }
    },

}
</script>
